import { jsx, jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import { forwardRef, useMemo } from "react";
import { Loading } from "./loading.js";
import "./vanilla-extract-dynamic.esm-b0bca947.js";
const style_css_ts_vanilla = "";
var button = "q047v90";
var buttonIcon = "q047v91";
var iconButton = "q047v92";
const defaultProps$1 = {
  type: "default",
  disabled: false,
  shape: "default",
  size: "default",
  iconPosition: "start",
  loading: false,
  withoutHoverStyle: false
};
const ButtonIcon = (props) => {
  const {
    size,
    icon,
    iconPosition = "start",
    children,
    type,
    loading,
    withoutHoverStyle,
    ...otherProps
  } = {
    ...defaultProps$1,
    ...props
  };
  const onlyIcon = icon && !children;
  return /* @__PURE__ */ jsx(
    "div",
    {
      ...otherProps,
      className: clsx(buttonIcon, {
        "color-white": type !== "default" && type !== "plain",
        large: size === "large",
        extraLarge: size === "extraLarge",
        end: iconPosition === "end" && !onlyIcon,
        start: iconPosition === "start" && !onlyIcon,
        loading
      }),
      "data-without-hover": withoutHoverStyle,
      children: icon
    }
  );
};
const Button = forwardRef(
  (props, ref) => {
    const {
      children,
      type,
      disabled,
      shape,
      size,
      icon: propsIcon,
      iconPosition,
      block,
      loading,
      withoutHoverStyle,
      className,
      ...otherProps
    } = {
      ...defaultProps$1,
      ...props
    };
    const icon = useMemo(() => {
      if (loading) {
        return /* @__PURE__ */ jsx(Loading, {});
      }
      return propsIcon;
    }, [propsIcon, loading]);
    const baseIconButtonProps = useMemo(() => {
      return {
        size,
        iconPosition,
        icon,
        type,
        disabled,
        loading
      };
    }, [disabled, icon, iconPosition, loading, size, type]);
    return /* @__PURE__ */ jsxs(
      "button",
      {
        ...otherProps,
        ref,
        className: clsx(
          button,
          {
            primary: type === "primary",
            plain: type === "plain",
            error: type === "error",
            warning: type === "warning",
            success: type === "success",
            processing: type === "processing",
            large: size === "large",
            extraLarge: size === "extraLarge",
            disabled,
            circle: shape === "circle",
            round: shape === "round",
            block,
            loading,
            "without-hover": withoutHoverStyle
          },
          className
        ),
        disabled,
        "data-disabled": disabled,
        children: [
          icon && iconPosition === "start" ? /* @__PURE__ */ jsx(
            ButtonIcon,
            {
              ...baseIconButtonProps,
              ...props.componentProps?.startIcon,
              icon,
              iconPosition: "start"
            }
          ) : null,
          /* @__PURE__ */ jsx("span", { children }),
          icon && iconPosition === "end" ? /* @__PURE__ */ jsx(
            ButtonIcon,
            {
              ...baseIconButtonProps,
              ...props.componentProps?.endIcon,
              icon,
              iconPosition: "end"
            }
          ) : null
        ]
      }
    );
  }
);
Button.displayName = "Button";
const defaultProps = {
  type: "plain",
  disabled: false,
  size: "default",
  loading: false,
  withoutPadding: false,
  active: false,
  withoutHoverStyle: false
};
const IconButton = forwardRef(
  (props, ref) => {
    const {
      type,
      size,
      withoutPadding,
      children,
      disabled,
      loading,
      active,
      withoutHoverStyle,
      icon: propsIcon,
      className,
      ...otherProps
    } = {
      ...defaultProps,
      ...props
    };
    return /* @__PURE__ */ jsx(
      "button",
      {
        ref,
        className: clsx(
          iconButton,
          {
            "without-padding": withoutPadding,
            primary: type === "primary",
            plain: type === "plain",
            error: type === "error",
            warning: type === "warning",
            success: type === "success",
            processing: type === "processing",
            large: size === "large",
            small: size === "small",
            "extra-small": size === "extraSmall",
            disabled,
            loading,
            active,
            "without-hover": withoutHoverStyle
          },
          className
        ),
        disabled,
        "data-disabled": disabled,
        ...otherProps,
        children: loading ? /* @__PURE__ */ jsx(Loading, {}) : children || propsIcon
      }
    );
  }
);
IconButton.displayName = "IconButton";
export {
  Button,
  IconButton
};
